import { formatDateTimeToString } from "go-core/components/Formatters/FormatDate";

const get30DaysAgoDate = () => {
	const now = new Date();
	const monthAgoDate = new Date(new Date().setDate(now.getDate() - 29));
	monthAgoDate.setHours(0, 0, 0, 0);
	return formatDateTimeToString(monthAgoDate);
};

export const getJpkDateRangeDefaultValue = () => {
	const now = new Date();
	now.setHours(0, 0, 0, 0);
	const nowAsString = formatDateTimeToString(now);
	return `${get30DaysAgoDate()} - ${nowAsString}`;
};
